import React, { useMemo, useState } from 'react';
import classnames from 'classnames';
import { withStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';
import Grid from '@material-ui/core/Grid';
import TextField from '@material-ui/core/TextField';
import styles from './styles';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import Typography from '@material-ui/core/Typography';
import { useDwlLocationUsers } from 'common/hooks/dwlLocationUsers';
import DwlContactAdder from 'components/DwlContactAdder';
import { useSelector } from 'react-redux';

const RedirectVerifyModal = ({ classes, isOpen, onSave, onClose, onCancel, sheet }) => {
  const [dwlVerificationContacts, setDwlVerificationContacts] = useState([]);
  const { dwlLocationUsers } = useDwlLocationUsers();
  const personalProfile = useSelector((store) => store.personalProfile.user);

  const lastSubmission = useMemo(() => {
    const submissions = [...(sheet?.submissions || [])]
    return submissions.sort((a, b) => new Date(b?.createdAt).getTime() - new Date(a?.createdAt).getTime())?.[0];
  }, [sheet])

  const availableDwlUsers = useMemo(() => {
    return dwlLocationUsers.filter(user =>
      (
        !dwlVerificationContacts?.includes(user._id) &&
        lastSubmission?.dwlVerification?.every(contact => contact.userId !== user._id) &&
        user._id !== personalProfile._id
    ));
  }, [lastSubmission, dwlVerificationContacts, sheet, dwlLocationUsers, personalProfile])

  const handleSelectContact = (value) => {
    setDwlVerificationContacts(
      [...dwlVerificationContacts, value]
    );
  }
  const handleDeleteContact = (userId) => {
    setDwlVerificationContacts(dwlVerificationContacts.filter(uId => uId !== userId));
  }

  const handleSave = () => {
    onSave(dwlVerificationContacts)
    setDwlVerificationContacts([]);
  }

  const handleClose = () => {
    setDwlVerificationContacts([]);
  }


  return (
    <Dialog
      open={isOpen}
      onClose={onClose}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
      PaperProps={{
        classes: {
          root: classes.dialogRoot,
        },
      }}
    >
      <IconButton
        className={classes.closeButton}
        onClick={() => {
          onClose();
          handleClose();
        }}
        aria-label="Close"
        disableTouchRipple
      >
        <CloseIcon />
      </IconButton>

      <DialogTitle id="alert-dialog-title">
        <Typography variant="h2" className={classes.title}>Verify</Typography>
      </DialogTitle>

      <DialogContent>
        <Typography variant="h5" className={classes.text}>Please choose Internal Point of Contact</Typography>
        <Grid item xs={12} md={12}>
          <div className={classnames(classes.flexColumn, classes.fullWidth)}>
            <div className={classnames(classes.flexBox, classes.fullWidth, classes.pr3)}>
              <DwlContactAdder
                options={availableDwlUsers}
                onSelect={handleSelectContact}
              />
            </div>
            {dwlVerificationContacts
              .map(userId => dwlLocationUsers.find((u) => userId === u._id))
              .filter(u => !!u)
              .map((user, i) => {
                return (
                  <Grid key={user._id} container item xs={12} spacing={1} style={{ position: 'relative' }}>
                    <Grid item xs={6}>
                      <Typography variant="body1" color="textSecondary" style={{ margin: 0 }}>
                        Name:
                      </Typography>
                    </Grid>
                    <Grid item xs={6}>
                      <Typography variant="body1" color="textSecondary" style={{ margin: 0 }}>
                        Email:
                      </Typography>
                    </Grid>
                    <Grid item xs={6}>
                      <TextField
                        value={user.profile.fullName || user.username}
                        disabled
                        fullWidth
                        variant="outlined"
                        className={classnames(classes.textField, classes.customSelect)}
                      />
                    </Grid>
                    <Grid item xs={6}>
                      <TextField
                        value={user.profile.email}
                        disabled
                        fullWidth
                        variant="outlined"
                        className={classnames(classes.textField, classes.customSelect)}
                      />
                    </Grid>
                      <div
                        className={classes.delCustomSelectIcon}
                        onClick={() => handleDeleteContact(user._id)}
                        aria-label="Delete"
                      >
                        <CloseIcon />
                      </div>
                  </Grid>
                );
              })
            }
          </div>
        </Grid>
      </DialogContent>

      <DialogActions style={{ justifyContent: 'space-around' }}>
        <Button
          color="secondary"
          variant="outlined"
          className={classes.cancelButton}
          onClick={() => {
            onCancel();
            handleClose();
          }}
          disableTouchRipple
        >
          No
        </Button>
        <Button
          type="submit"
          color="primary"
          variant="outlined"
          className={classes.saveButton}
          disabled={!dwlVerificationContacts?.length}
          onClick={handleSave}
          disableTouchRipple
        >
          Yes
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default withStyles(styles)(RedirectVerifyModal);
